import React, { useState } from "react";
import { Dialog } from "../containers/Dialog.tsx";
import { Button } from "../widgets/Button.tsx";
import { useShareWorkoutRoutine } from "../../api/hooks.ts";
import { WorkoutRoutine, User } from "../../api/types.ts";
import { useDialog } from "../DialogManager.tsx";
import { Select } from "../inputs/Select.tsx";

interface ShareRoutineDialogProps {
  open: boolean;
  closeDialog: () => void;
  routine: WorkoutRoutine;
  friends: Partial<User>[];
}

const ShareRoutineDialog: React.FC<ShareRoutineDialogProps> = ({
  open,
  closeDialog,
  routine,
  friends,
}) => {
  const { setError } = useDialog();
  const [friendId, setFriendId] = useState<string | null>(null);

  const shareWorkoutRoutineMutation = useShareWorkoutRoutine();

  const handleSave = () => {
    const shareData = {
      friendId: friendId!,
      routineId: routine.id,
    };

    shareWorkoutRoutineMutation.mutate(shareData, {
      onSuccess: () => {
        closeDialog();
      },
      onError: (error) => {
        setError(error as Error);
      },
    });
  };

  const handleCancel = () => {
    setFriendId(null);
    closeDialog();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      title={`Share "${routine.name}"`}
    >
      <Dialog.Content>
        <p className="mb-4">
          Share your workout routine with one of your friends.
        </p>
        <Select
          required
          value={friendId || ""}
          options={[{ id: "", label: "Select an option" }].concat(
            friends.map((friend) => ({
              id: friend.id!,
              label: friend.name!,
            })),
          )}
          onChange={(value) => setFriendId(value)}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          variant="submit"
          onClick={handleSave}
          disabled={!friendId}
          loading={shareWorkoutRoutineMutation.isPending}
        >
          Share
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export { ShareRoutineDialog };
